import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  initGoogleAnalytics,
  trackPageView,
  getGaMeasurementId,
  getGoogleAdsId,
  trackContactClick
} from '../utils/googleAnalytics.js';

/**
 * Initializes GA4, tracks page views across SPA route transitions,
 * and captures global contact micro-conversions (WhatsApp & phone clicks).
 */
export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    try {
      if (getGaMeasurementId()) {
        initGoogleAnalytics();
      }
    } catch {
      // Non-blocking fail-safe
    }
  }, []);

  useEffect(() => {
    try {
      if (getGaMeasurementId()) {
        initGoogleAnalytics();
        trackPageView(`${location.pathname}${location.search}`);
      }
      // Fire page_view for Google Ads tag on route changes
      if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        const adsId = getGoogleAdsId();
        window.gtag('config', adsId, {
          page_path: `${location.pathname}${location.search}`,
          allow_enhanced_conversions: true
        });
      }
    } catch {
      // Non-blocking fail-safe
    }
  }, [location.pathname, location.search]);

  // Global delegated click listener for WhatsApp and Phone call conversions
  useEffect(() => {
    const handleContactClick = (e) => {
      try {
        const link = e.target.closest('a');
        if (!link || !link.href) return;
        const href = String(link.href);

        if (href.startsWith('tel:')) {
          const phoneNumber = href.replace(/^tel:/, '');
          trackContactClick({ type: 'phone', destination: phoneNumber });
        } else if (href.includes('wa.me') || href.includes('whatsapp.com')) {
          trackContactClick({ type: 'whatsapp', destination: href });
        }
      } catch {
        // Non-blocking fail-safe
      }
    };

    document.addEventListener('click', handleContactClick, { passive: true });
    return () => {
      document.removeEventListener('click', handleContactClick);
    };
  }, []);

  return null;
}
